import { useEffect, useState } from "react";
import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import api from "@/lib/api";

const ChartTip = ({ active, payload, label }) => {
  if (!active || !payload?.length) return null;
  return (
    <div className="bg-[#0C1428] border border-white/15 px-4 py-3" data-testid="analytics-tooltip">
      <p className="font-grotesk text-[10px] uppercase tracking-[0.15em] text-white/50 mb-2">{label}</p>
      {payload.map((p) => (
        <p key={p.dataKey} className="font-grotesk text-xs" style={{ color: p.color }}>
          {p.dataKey === "model" ? "Talent" : "Brands"} — {p.value}
        </p>
      ))}
    </div>
  );
};

export default function AdminAnalytics() {
  const [data, setData] = useState(null);
  useEffect(() => {
    api.get("/admin/analytics").then((r) => setData(r.data)).catch(() => {});
  }, []);
  if (!data) return null;

  return (
    <section className="panel p-8 mb-16" data-testid="admin-analytics">
      <div className="flex flex-wrap items-end justify-between gap-6 mb-8">
        <div>
          <p className="overline-label !font-semibold !text-white/85 mb-2">Growth — signups, last 30 days</p>
          <p className="font-grotesk text-xs text-white/40">Who is joining the room, day by day</p>
        </div>
        <div className="flex gap-10">
          {[
            [data.totals.model, "Talent", "analytics-talent-total"],
            [data.totals.employer, "Brands", "analytics-brands-total"],
            [data.signups_7d, "New this week", "analytics-week-total"],
          ].map(([n, label, tid]) => (
            <div key={tid}>
              <p className="font-display text-3xl" data-testid={tid}>{n}</p>
              <p className="overline-label !text-[9px]">{label}</p>
            </div>
          ))}
        </div>
      </div>
      <div className="flex gap-6 mb-4">
        <span className="flex items-center gap-2 font-grotesk text-[10px] uppercase tracking-[0.15em] text-white/60">
          <span className="inline-block w-3 h-3 bg-[#f9f9f9]" /> Talent
        </span>
        <span className="flex items-center gap-2 font-grotesk text-[10px] uppercase tracking-[0.15em] text-white/60">
          <span className="inline-block w-3 h-3 bg-[#C8102E]" /> Brands
        </span>
      </div>
      <div className="h-64" data-testid="analytics-chart">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data.days} margin={{ top: 4, right: 0, bottom: 0, left: -18 }} barCategoryGap="25%">
            <CartesianGrid vertical={false} stroke="rgba(255,255,255,0.06)" />
            <XAxis dataKey="label" interval={4} tick={{ fill: "rgba(255,255,255,0.4)", fontSize: 10, fontFamily: "Space Grotesk" }} tickLine={false} axisLine={{ stroke: "rgba(255,255,255,0.15)" }} />
            <YAxis allowDecimals={false} tick={{ fill: "rgba(255,255,255,0.4)", fontSize: 10, fontFamily: "Space Grotesk" }} tickLine={false} axisLine={false} />
            <Tooltip content={<ChartTip />} cursor={{ fill: "rgba(255,255,255,0.04)" }} />
            <Bar dataKey="model" stackId="a" fill="#f9f9f9" name="Talent" />
            <Bar dataKey="employer" stackId="a" fill="#C8102E" name="Brands" />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </section>
  );
}
